import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Serviço que expõe o título da página de relatórios atual (ex: "Comission Reports").
 * O componente Reports atualiza o título quando a rota muda; componentes filhos (ComissionReports, Comission NFs, Raio X Dealer)
 * podem ler para usar no nome do PDF exportado.
 */
@Injectable({
  providedIn: 'root'
})
export class ReportPageContextService {
  private readonly titleSubject = new BehaviorSubject<string>('');
  readonly title$: Observable<string> = this.titleSubject.asObservable();

  setTitle(title: string): void {
    this.titleSubject.next(title ?? '');
  }

  getTitle(): string {
    return this.titleSubject.value;
  }
}
